
import React from "react"
import Footer from './footer'
import SEO from './seo'
import Header from "./header"



const Layout = ({ children }) => {

  return (
  <>
  <SEO title={'Haslam Logistics | Same-day delivery specialists'} />
      <Header />

        <main>{children}</main>
        
      <Footer />
    </>
  )
}



export default Layout
